<template>
  <button
    :title="$t('sharing.whatsapp')"
    type="button"
    class="whatsapp"
    @click="share"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      fill="none"
      class="h-full w-full"
    >
      <rect
        width="29.5"
        height="29.5"
        x=".3"
        y=".3"
        stroke="#fff"
        stroke-width=".5"
        rx="14.8"
      />
      <path
        fill="#fff"
        d="M22 8A9.4 9.4 0 0 0 7.3 19.3L6 24l5-1.4c1.4.8 3 1.2 4.5 1.2A9.4 9.4 0 0 0 22 8zm-6.6 14.4c-1.4 0-2.8-.4-4-1l-.3-.3-3 .8L9 19l-.2-.3a7.8 7.8 0 0 1 6.6-12 7.8 7.8 0 0 1 7.8 7.9c0 4.3-3.5 7.8-7.8 7.8z"
      />
      <path
        fill="#fff"
        d="M12.5 10.2h-.3l-.4.1-.3.2-.2.3c-.4.5-.6 1-.6 1.6 0 .5.1 1 .3 1.4a9.1 9.1 0 0 0 2.5 3.2 9 9 0 0 0 4.2 2h.6c.3 0 .6 0 .8-.2l.4-.2.4-.3.2-.3.2-.7v-.4s0-.2-.2-.2l-.5-.3-1.4-.6H18l-.3.1-.8.9a.3.3 0 0 1-.3.1h-.2l-.3-.2a5.8 5.8 0 0 1-1.8-1.2 6 6 0 0 1-1-1.3l-.1-.2v-.3l.4-.4.2-.4c.1-.1.2-.3.1-.5a81 81 0 0 0-1.2-2.2h-.2"
      />
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    encodedUrl() {
      return encodeURI(this.url)
    },
    encodedText() {
      return encodeURI(this.text)
    },
  },
  methods: {
    share() {
      this.$store.dispatch('tracking/trackGeneric', {
        category: 'sharing',
        action: 'whatsapp',
        label: this.text,
      })
      let url =
        `https://web.whatsapp.com/send?text=` +
        `${this.encodedText} - ${this.encodedUrl}`
      // we assume that if it's a mobile device and the user wants to share to whatsapp the app is isntalled.
      if (/android|iPad|iPhone|iPod/i.test(navigator.userAgent)) {
        url = `whatsapp://send?text=${this.encodedText} - ${this.encodedUrl}`
      }
      window.open(url, '_blank', 'width=500,height=400')
    },
  },
}
</script>
